import { ApiUtil } from 'lecom-api';

export default class FormStoreValuesSynchronizer {

	static sync(gridFormName, values) {
		const fieldAPI = ApiUtil.getFieldAPI(gridFormName);
		const formAPI = ApiUtil.getFormAPI();

		const isMobile = formAPI.isMobile();

		Object.keys(values)
			.filter(dataRowKey => !dataRowKey.includes('Display') && dataRowKey !== 'id')
			.forEach(fieldId => {
				let value = values[fieldId];

				if (value === null || value === undefined)
					value = "";

				if (typeof value === 'string')
					value = value.trim();

				if (isMobile && fieldAPI.fields(fieldId).type() === 'DATE' && document.getElementById(fieldId)) {
					setTimeout(() => {
						document.getElementById(fieldId).value = '';
					}, 0);
				}

				fieldAPI.fields(fieldId).warnings("").value(value);
			});

		return formAPI.apply();
	}
}
